import { Injectable } from '@angular/core';
import { CacheService } from '@ngx-cache/core';
import { CacheDuration } from '../constants/app.constant';
import { EncryptionService } from '../services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class CacheResolverService {

  constructor(private readonly cache: CacheService, private encryptionService: EncryptionService) {
  }

  get(key: string): any {
    let value;

    try {
      value = this.encryptionService.decryptData(this.cache.get(key));
    } catch (error) {
    }

    return value || undefined;
  }


  set(key: string, value: any, expiry?: number): boolean {
    expiry = expiry || CacheDuration.Default;
    value = this.encryptionService.encryptData(value);
    return this.cache.set(key, value, 0, {
      expiry:
        expiry >= Number.MAX_VALUE
          ? Number.MAX_VALUE
          : Date.now() + expiry * 1000,
      TTL: expiry
    });
  }

  setAndGet(key: string, value: any, expiry?: number): any {
    this.set(key, value, expiry);
    return this.get(key);
  }


  has(key: string): boolean {
    const value = this.get(key);
    return value ? true : false;
  }

  remove(key: string) {
    this.cache.remove(key);
  }

  clear(): void {
    this.cache.clear();
  }
}
